import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { dataAll } from '../../../../service/data.service';
import { Loading } from '../../../../components/Loading';
import ComparativoReceitaRecebidoTable from '../../../../components/Financial/ComparativoReceitaRecebido/Table';
import ComparativoReceitaRecebidoFilter from '../../../../components/Financial/ComparativoReceitaRecebido/Filter';

const filterSample = { year: '', month: '', state: '', franchisee: '' }

const ComparativoReceitaRecebidoClube = () => {

  const [isLoading, setIsLoading] = useState(false)
  const [filters, setFilters] = useState(filterSample)
  const [relatorio, setRelatorio] = useState({})
  const [pesquisaRealizada, setPesquisaRealizada] = useState(false)

  const fetchAllItems = async (filter) => {
    try {
      setIsLoading(true)
      const response = await dataAll('/club/income-received-comparison', { params: filter })
      setRelatorio(response || {
        "manualBillingsReceived": 0,
        "taxesFromOfx": 0,
        "taxesFromM3tas": 0,
      })

    } catch (error) {
      toast.error('Erro ao buscar relatório comparativo receita x recebido. Favor tentar novamente dentro de alguns instantes. Sinalize o suporte caso persista. Erro técnico:', error)

    } finally {
      setIsLoading(false)
      setPesquisaRealizada(true)
    }
  }

  const clickFilter = () => {
    fetchAllItems(filters)
  }

  const clearFilter = () => {
    const currentYear = new Date().getFullYear()
    const currentMonth = new Date().getMonth() + 1
    setFilters({ ...filterSample, month: currentMonth, year: currentYear})
  }

  useEffect(() => {
    clearFilter()
  }, [])

  return (
    <>
      <ComparativoReceitaRecebidoFilter
        filters={filters}
        setFilters={setFilters}
        clickFilter={clickFilter}
        clearFilter={clearFilter}
        isClub
      />

      {
        isLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '128px' }}>
            <Loading />
          </div>
        ) : (
          pesquisaRealizada && relatorio.map((report) => (
            <ComparativoReceitaRecebidoTable
              key={report.tenant_id}
              relatorio={report.tenantReport}
              franquia={report.tenant_id}
            />
          ))
        )
      }
    </>
  )

}

export default ComparativoReceitaRecebidoClube